import React from 'react';
import PropTypes from 'prop-types';
import OpenEndedNumericInput from '../../OpenEndedNumericInput';
import { getStyles } from '../../utils';
import { transformPrompt } from '../../../../../../utils';

export default function Columns({
  rowId,
  rowRefId,
  rowOrder,
  columns,
  openEndedStyle,
  openEndedInputSize,
  openEndedSignPlacement,
  openEndedSign,
  min,
  max,
  decimals,
  onChange,
}) {
  const { answerStyle, inputStyle, containerClasses } = getStyles(
    openEndedInputSize,
    openEndedStyle,
  );

  return (
    <div className={`${answerStyle} scrollbox`}>
      {columns.map((column, index) => (
        <div id={column.id} className={containerClasses}>
          <div
            className="answer--matrix-open-ended-column-label inline-children"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: transformPrompt(column.label) || '&nbsp;',
            }}
          />
          <OpenEndedNumericInput
            rowId={rowId}
            rowRefId={rowRefId}
            rowOrder={rowOrder}
            columnId={column.id}
            columnRefId={column.refId}
            columnOrder={index}
            openEndedInputSize={openEndedInputSize}
            openEndedSignPlacement={openEndedSignPlacement}
            openEndedSign={openEndedSign}
            min={min}
            max={max}
            decimals={decimals}
            required={column.required}
            inputStyle={inputStyle}
            onChange={onChange}
          />
        </div>
      ))}
    </div>
  );
}

Columns.propTypes = {
  rowId: PropTypes.number,
  rowRefId: PropTypes.string,
  rowOrder: PropTypes.number,
  columns: PropTypes.array,
  openEndedStyle: PropTypes.string,
  openEndedInputSize: PropTypes.string,
  openEndedSign: PropTypes.string,
  openEndedSignPlacement: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  decimals: PropTypes.number,
  onChange: PropTypes.func,
};
